// extracted by mini-css-extract-plugin
export default {"Box":"PTManagement_Box__kJ0Rr","TutorRows":"PTManagement_TutorRows__wKuO9"};